import { combineEpics } from 'redux-observable';

import * as ActionCreators from '../actions/ActionCreators';
import * as ActionTypes from '../actions/ActionTypes';
import * as ADBPEventType from '../tracking/ADBPEventType';


const trackShareSocialEpic = (action$, store, { }) => action$
    .ofType(ActionTypes.ON_SHARE_SOCIAL)
    .pluck('payload', 'currentTarget')
    .map(currentTarget => ActionCreators.trackUserInteraction(currentTarget.getAttribute('data-user-interaction')));


const trackVideoProgressEpic = (action$, store, { player, options }) => action$
    .ofType(ActionTypes.SET_VIDEO_PROGRESS_STATE)
    .filter(() => !!options.tracking)
    .map(() => store.getState().player.videoProgress) // get progress
    .filter((progress) => (progress % 60) === 0 && progress > 0) // only fire every 60 seconds
    .map(() => ActionCreators.trackVideoProgress()); // track duration


const trackVideoFiftyEpic = (action$, store, { player, options }) => action$
    .ofType(ActionTypes.SET_VIDEO_PROGRESS_STATE)
    .pluck('payload')
    .filter(() => !!options.tracking)
    .filter(() => !store.getState().player.videoFiftyReached) // don't fire if video fifty has been reached
    .filter((progress) => progress > (store.getState().videoSource.duration / 2)) // only fire if progress has reached greater than half the duration
    .map(() => ActionCreators.trackVideoFifty()); // track duration


// tracks when content starts
const trackVideoStartEpic = (action$, store, { }) => action$
    .ofType(ActionTypes.SET_STARTED_STATE)
    .map(() => ActionCreators.trackVideoStart());


// tracks whenever video is in a waiting state
const trackVideoCompleteEpic = (action$, store, { }) => action$
    .ofType(ActionTypes.PLAYER_EVENT_ENDED)
    .filter(() => !store.getState().player.adPlaying) // only when ad isn't playing
    .map(() => ActionCreators.trackVideoComplete());


// tracks whenever pause state is changed
// changes when video starts from a stopped state, on seek (pauses then unpauses if previously playing), or user pause/unpause
const trackVideoPauseEpic = (action$, store, { }) => action$
    .ofType(ActionTypes.SET_PAUSE_STATE)
    .map(() => ActionCreators.trackVideoPause());


// tracks whenever video is in a waiting state
const trackVideoBufferingEpic = (action$, store, { }) => action$
    .ofType(ActionTypes.SET_WAITING_STATE)
    .filter((data) => !!data.payload)
    .map(() => ActionCreators.trackVideoBuffering());


const trackPrerollEpic = (action$, store, { }) => action$
    .ofType(ActionTypes.ADS_EVENT_SLOT_STARTED)
    .map(data => data.payload.slot.getTimePositionClass())
    .filter((timePositionClass) => (timePositionClass === tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL))
    .map(() => ActionCreators.trackPreroll());


const trackMidrollStartEpic = (action$, store, { }) => action$
    .ofType(ActionTypes.ADS_EVENT_SLOT_STARTED)
    .map(data => data.payload.slot.getTimePositionClass())
    .filter((timePositionClass) => (timePositionClass === tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL))
    .map(() => ActionCreators.trackMidrollStart());


const trackMidrollEndEpic = (action$, store, { }) => action$
    .ofType(ActionTypes.ADS_EVENT_SLOT_ENDED)
    .map(data => data.payload.slot.getTimePositionClass())
    .filter((timePositionClass) => (timePositionClass === tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL))
    .map(() => ActionCreators.trackMidrollEnd());


const trackPostrollStartEpic = (action$, store, { }) => action$
    .ofType(ActionTypes.ADS_EVENT_SLOT_STARTED)
    .map(data => data.payload.slot.getTimePositionClass())
    .filter((timePositionClass) => (timePositionClass === tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL))
    .map(() => ActionCreators.trackPostrollStart());


const trackPostrollEndEpic = (action$, store, { }) => action$
    .ofType(ActionTypes.ADS_POSTROLL_END)
    .map(() => ActionCreators.trackPostrollEnd());




const ADBPUserInteraction = (action$, store, { analytics, debug, player }) => action$
    .ofType(ActionTypes.TRACK_USER_INTERACTION)
    .filter(() => !!store.getState().videoSource.id)
    .filter(() => !!window.trackMetrics)
    .pluck('payload')
    .do(interactionType => {
        const userInteractionData = analytics.getUserInteractionData(store.getState().videoSource, interactionType);
        analytics.track(ADBPEventType.USER_INTERACTION, userInteractionData);
        debug.log(ADBPEventType.USER_INTERACTION, userInteractionData);
    })
    .ignoreElements();


const ADBPVideoStartEpic = (action$, store, { analytics, debug, player }) => action$
    .ofType(ActionTypes.TRACK_VIDEO_START)
    .filter(() => !!store.getState().videoSource.id)
    .filter(() => !!window.trackMetrics)
    .do(() => {
        const videoData = analytics.getVideoData(store.getState().videoSource, { duration: 0, autoplayed: player.autoplay() });
        analytics.track(ADBPEventType.VIDEO_START, videoData);
        debug.log(ADBPEventType.VIDEO_START, videoData);
    })
    .ignoreElements();


const ADBPVideoPauseEpic = (action$, store, { analytics, debug }) => action$
    .ofType(ActionTypes.TRACK_VIDEO_PAUSE)
    .filter(() => !!store.getState().videoSource.id)
    .filter(() => !!window.trackMetrics)
    .do(() => {
        const videoData = analytics.getVideoData(store.getState().videoSource, { paused: store.getState().player.pause });
        analytics.track(ADBPEventType.VIDEO_PAUSE, videoData);
        debug.log(ADBPEventType.VIDEO_PAUSE, videoData);
    })
    .ignoreElements();


const ADBPVideoBufferingEpic = (action$, store, { analytics, debug }) => action$
    .ofType(ActionTypes.TRACK_VIDEO_BUFFERING)
    .filter(() => !!store.getState().videoSource.id)
    .filter(() => !!window.trackMetrics)
    .do(() => {
        const videoData = analytics.getVideoData(store.getState().videoSource, { buffering: true });
        analytics.track(ADBPEventType.VIDEO_BUFFER, videoData);
        debug.log(ADBPEventType.VIDEO_BUFFER, videoData);
    })
    .ignoreElements();


const ADBPVideoProgressEpic = (action$, store, { analytics, debug }) => action$
    .ofType(ActionTypes.TRACK_VIDEO_PROGRESS)
    .filter(() => !!store.getState().videoSource.id)
    .filter(() => !!window.trackMetrics)
    .map(() => store.getState().player.videoProgress)
    .do((progress) => {
        const videoData = analytics.getVideoData(store.getState().videoSource, { duration: progress });
        analytics.track(ADBPEventType.VIDEO_PROGRESS, videoData);
        debug.log(ADBPEventType.VIDEO_PROGRESS, videoData);
    })
    .ignoreElements();


const ADBPVideoFiftyEpic = (action$, store, { analytics, debug }) => action$
    .ofType(ActionTypes.TRACK_VIDEO_FIFTY)
    .filter(() => !!store.getState().videoSource.id)
    .filter(() => !!window.trackMetrics)
    .map(() => store.getState().player.videoProgress)
    .do((progress) => {
        const videoData = analytics.getVideoData(store.getState().videoSource, { duration: progress });
        analytics.track(ADBPEventType.VIDEO_FIFTY, videoData);
        debug.log(ADBPEventType.VIDEO_FIFTY, videoData);
    })
    .ignoreElements();


const ADBPVideoCompleteEpic = (action$, store, { analytics, debug }) => action$
    .ofType(ActionTypes.TRACK_VIDEO_COMPLETE)
    .filter(() => !!store.getState().videoSource.id)
    .filter(() => !!window.trackMetrics)
    .do(() => {
        const videoData = analytics.getVideoData(store.getState().videoSource);
        analytics.track(ADBPEventType.VIDEO_COMPLETE, videoData);
        debug.log(ADBPEventType.VIDEO_COMPLETE, videoData);
    })
    .ignoreElements();


const ADBPPrerollEpic = (action$, store, { analytics, debug }) => action$
    .ofType(ActionTypes.TRACK_PREROLL)
    .filter(() => !!store.getState().videoSource.id)
    .filter(() => !!window.trackMetrics)
    .do(() => {
        const videoData = analytics.getVideoData(store.getState().videoSource);
        analytics.track(ADBPEventType.VIDEO_PREROLL, videoData);
        debug.log(ADBPEventType.VIDEO_PREROLL, videoData);
    })
    .ignoreElements();


const ADBPMidrollStartEpic = (action$, store, { analytics, debug }) => action$
    .ofType(ActionTypes.TRACK_MIDROLL_START)
    .filter(() => !!store.getState().videoSource.id)
    .filter(() => !!window.trackMetrics)
    .do(() => {
        const videoData = analytics.getVideoData(store.getState().videoSource);
        analytics.track(ADBPEventType.VIDEO_MIDROLL_START, videoData);
        debug.log(ADBPEventType.VIDEO_MIDROLL_START, videoData);
    })
    .ignoreElements();


const ADBPMidrollEndEpic = (action$, store, { analytics, debug }) => action$
    .ofType(ActionTypes.TRACK_MIDROLL_END)
    .filter(() => !!store.getState().videoSource.id)
    .filter(() => !!window.trackMetrics)
    .do(() => {
        const videoData = analytics.getVideoData(store.getState().videoSource);
        analytics.track(ADBPEventType.VIDEO_MIDROLL_COMPLETE, videoData);
        debug.log(ADBPEventType.VIDEO_MIDROLL_COMPLETE, videoData);
    })
    .ignoreElements();


const ADBPPostrollStartEpic = (action$, store, { analytics, debug }) => action$
    .ofType(ActionTypes.TRACK_POSTROLL_START)
    .filter(() => !!store.getState().videoSource.id)
    .filter(() => !!window.trackMetrics)
    .do(() => {
        const videoData = analytics.getVideoData(store.getState().videoSource);
        analytics.track(ADBPEventType.VIDEO_POSTROLL_START, videoData);
        debug.log(ADBPEventType.VIDEO_POSTROLL_START, videoData);
    })
    .ignoreElements();


const ADBPPostrollEndEpic = (action$, store, { analytics, debug, ads }) => action$
    .ofType(ActionTypes.TRACK_POSTROLL_END)
    .filter(() => !!store.getState().videoSource.id)
    .filter(() => !!window.trackMetrics)
    .do(() => {
        const videoData = analytics.getVideoData(store.getState().videoSource);
        analytics.track(ADBPEventType.VIDEO_POSTROLL_COMPLETE, videoData);
        debug.log(ADBPEventType.VIDEO_POSTROLL_COMPLETE, videoData);
    })
    .ignoreElements();




export default combineEpics(
    ADBPUserInteraction,
    ADBPVideoProgressEpic,
    ADBPVideoFiftyEpic,
    ADBPVideoStartEpic,
    ADBPVideoBufferingEpic,
    ADBPVideoPauseEpic,
    ADBPVideoCompleteEpic,
    ADBPPrerollEpic,
    ADBPMidrollStartEpic,
    ADBPMidrollEndEpic,
    ADBPPostrollStartEpic,
    ADBPPostrollEndEpic,
    trackShareSocialEpic,
    trackVideoCompleteEpic,
    trackVideoStartEpic,
    trackVideoBufferingEpic,
    trackVideoPauseEpic,
    trackVideoFiftyEpic,
    trackVideoProgressEpic,
    trackPrerollEpic,
    trackMidrollStartEpic,
    trackMidrollEndEpic,
    trackPostrollStartEpic,
    trackPostrollEndEpic,
);


// WEBPACK FOOTER //
// ./src/tracking/epics.js